export default __webpack_public_path__ + "static/media/waitingAvatar.ac5085db.png";